import * as R from 'ramda';

const getUser = (state) => state.user;
const getProfile = (state) => getUser(state) ? getUser(state).profile : null;
export const getUserId = state => getProfile(state) ? getProfile(state).id : null;
export const getUserFullName = (state) => {
    const profile = getProfile(state);
    if (!profile) {
        return null;
    }
    const {first_name, last_name} = profile;
    return `${first_name} ${last_name}`;
};
export const getUserEmail = (state) => {
    const profile = getProfile(state);
    if (!profile) {
        return null;
    }
    const {email} = profile;
    return email;
};
export const getPermissions = (state) => {
    const profile = getProfile(state);
    if (!profile) {
        return [];
    }
    const {permissions} = profile;
    return permissions;
};
export const isSuperUser = state => {
    const profile = getProfile(state);
    if (!profile) {
        return false;
    }
    return R.pathOr(false, ['is_superuser'], profile);
}

export const hasCPIPermission = state => {
    const CPI_PERM = 'view cpi data';
    const permissions = getPermissions(state);
    const cpis = permissions.filter(elm => elm.perm === CPI_PERM && elm.status === true);
    return cpis.length > 0;
}

export const hasClinicianPermission = state => {
    const entity = 'doctors';
    const view_perm = 'view';
    const permissions = getPermissions(state);
    const doctor_perms = permissions.filter(elm => elm.entity === entity && elm.perm === view_perm && elm.status === true);
    return doctor_perms.length > 0;
}